import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';

export type GetOrCreateUserByEmailRequest = { email: string; providerId?: string };
export type GetOrCreateUserByEmailResponse = {
  canonicalUid: string;
  ownerUid: string;
  normalizedEmail: string;
  emailHash: string;
  conflict: boolean;
  providers: string[];
};

export function normalizeEmailClient(raw: string): string {
  if (typeof raw !== 'string') throw new Error('INVALID_EMAIL');
  const e = raw.trim().toLowerCase();
  const BASIC_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!BASIC_EMAIL_REGEX.test(e)) throw new Error('INVALID_EMAIL');
  return e;
}

export async function getOrCreateUserByEmailClient(email: string, providerId?: string): Promise<GetOrCreateUserByEmailResponse> {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('NOT_AUTHENTICATED');
  const normalized = normalizeEmailClient(email);
  const fn = httpsCallable<GetOrCreateUserByEmailRequest, GetOrCreateUserByEmailResponse>(getFunctions(), 'getOrCreateUserByEmail');
  try {
    const res = await fn({ email: normalized, providerId });
    return res.data;
  } catch (e: any) {
    // One bounded retry on transient transport/server errors only (never on
    // permission-denied). Every caller treats a failure here as "proceed
    // without mapping", so a single cold start or network blip used to
    // silently skip the mapping ensure + stale-mapping self-heal for the
    // whole session.
    const code = String(e?.code || '');
    const transient =
      code.includes('internal') ||
      code.includes('unavailable') ||
      code.includes('deadline-exceeded') ||
      code.includes('network');
    if (!transient) throw e;
    await new Promise((resolve) => setTimeout(resolve, 1500));
    const res = await fn({ email: normalized, providerId });
    return res.data;
  }
}


